import { configureStore } from "@reduxjs/toolkit";
import StaffReducer from "./staffReducer";

export default configureStore({
  reducer: {
    staff_Data: StaffReducer,
  },
});
